import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

function DeleteAll() {
    const { t } = useTranslation('prepaidCard');
    const { push } = useFlow();
    const handleDeleteAll = () => {
        push('DeleteAllPrepaidCardsModal', {});
    };
    return (
        <Container justify='flex-end'
            fullWidth >
            <DeleteText color={colors.gray9}
                fontWeight='bold'
                size='lg'
                onClick={handleDeleteAll} >
                {t('manage.deleteAll')}
            </DeleteText>
            <Tooltip right='unset' left={8} top={28}
                visibleKey='favoritePrepaidCard'
                backgroundColor={colors.gray6}
                align='left' >
                {t('manage.favoriteTooltip')}
            </Tooltip>
        </Container>
    );
}

const Container = styled(Row)`
    padding: 24px 20px;
    position: relative;
`;

const DeleteText = styled(Text)`
    text-decoration: underline;
    text-underline-offset: 3px;
`;

export default DeleteAll;
